{
    "PasswordChange_Title": "Modifica della password",
    "PasswordChange_SubTitle": "Inserire la password attuale, la nuova password desiderata (è richiesto un minimo di caratteri {}) e la nuova password per confermare il nuovo valore.",
    "PasswordChange_Fields_OldPassword": "Password corrente",
    "PasswordChange_Fields_NewPassword": "Nuova password",
    "PasswordChange_Fields_ConfirmPassword": "Conferma la nuova password",
    "PasswordChange_Validations_PasswordsMustMatch": "Le password non corrispondono",
    "PasswordChange_Validations_CurrentRequired": "È richiesta la password corrente",
    "PasswordChange_Validations_NewRequired": "È necessaria una nuova password",
    "PasswordChange_Validations_ConfirmRequired": "È necessario confermare la password",
    "PasswordChange_Actions_ChangePassword": "Modifica della password",
    "PasswordChange_Actions_Cancel": "Annullamento",
    "NAME": "PasswordChangeLanguage",
    "PasswordReset_Title": "Reimpostazione password",
    "PasswordReset_SubTitle": "Inserisci la nuova password desiderata (sono richiesti almeno {} caratteri) e ripetila per confermarne il nuovo valore.",
    "PasswordReset_Success": "Hai aggiornato correttamente la password del tuo account utente. \n \n Fai clic sul pulsante **Continua** che ti riporterà alla pagina principale di benvenuto, dove potrai anche fare clic sul collegamento \"Accedi\" per accedere al tuo account.",
    "PasswordChange_Actions_Continue": "Continuare"
}